export const pipe =
    (...fns: CallableFunction[]) =>
    (x: unknown) =>
        fns.reduce((v, f) => f(v), x);
